// extracted by mini-css-extract-plugin
module.exports = {"textArea":"_3h8uMmok2-Bvu-2lY3zPi3"};